import type { IconData } from '@stacksjs/iconify-core'

export const contentStar: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12.473 10.254l.471 5.346L8 13.5l-4.944 2.1l.471-5.346L0 6.206l5.236-1.204L8 .4l2.764 4.602L16 6.206z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentStar
